/**
 * Location utility functions
 */

// Valid office locations
const VALID_OFFICE_LOCATIONS = [
  'Chennai',
  'Coimbatore', 
  'Bangalore',
  'Bengaluru',
  'Hyderabad'
];

/**
 * Processes location to mark as "Remote" if not in valid office locations
 * @param {string} location - The original location
 * @returns {string} - The processed location ("Remote" if not in valid locations)
 */
export const processLocation = (location) => {
  if (!location || typeof location !== 'string') {
    return 'Remote';
  }

  // Trim whitespace and normalize case for comparison
  const normalizedLocation = location.trim();
  
  // Find the matching valid office location (case-insensitive)
  const matchedLocation = VALID_OFFICE_LOCATIONS.find(
    validLocation => validLocation.toLowerCase() === normalizedLocation.toLowerCase()
  );

  // Return the properly formatted location name if found, otherwise "Remote"
  return matchedLocation || 'Remote';
};

/**
 * Gets the list of valid office locations
 * @returns {string[]} - Array of valid office locations
 */
export const getValidOfficeLocations = () => {
  return [...VALID_OFFICE_LOCATIONS];
};
